(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Swatch hover → change card image (same behavior as home "Lo más vendido")
  if (!window.__mfSwatchHover) {
    window.__mfSwatchHover = true;
    document.addEventListener('mouseover', (e) => {
      const label = e.target.closest('.variant-option__swatch label[data-swatch-img]');
      if (!label) return;
      const imgUrl = label.getAttribute('data-swatch-img');
      if (!imgUrl) return;
      const card = label.closest('product-card');
      if (!card || card.dataset.mfSwatchImg === imgUrl) return;
      card.dataset.mfSwatchImg = imgUrl;
      card.querySelectorAll('.card-gallery img').forEach((img) => {
        img.setAttribute('srcset', '');
        img.src = imgUrl;
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
